import { ISubstanceDto, IProductForm } from '@common/features/submission/types';
import * as Styled from './styles';
import { Button } from '@common/components/Button/Button';
import { ButtonTypes } from '@common/components/Button/types';
import theme from '@common/theme';

interface Props {
  isModal?: boolean;
  title: string;
  newLookups: IProductForm[] | ISubstanceDto[];
  onManageClick?: (id: string) => void;
}

export const LookupWarning = ({ isModal = false, title, newLookups, onManageClick }: Props) => {
  return (
    <Styled.WarningWrapper fullWidth={isModal}>
      <Styled.WarningContent>
        {!isModal && <Styled.WarningIcon src="/icons/warning-sign.svg" />}
        <Styled.WarningText>
          <Styled.Message>{title}</Styled.Message>
          {newLookups.map((lookup) => (
            <Button
              key={`${lookup.name}-${lookup.id}`}
              type={ButtonTypes.TEXT}
              text={lookup!.name}
              icon="/icons/update.svg"
              height={30}
              onClick={() => {
                onManageClick && onManageClick(lookup.id!);
              }}
              color={theme.colors.mediumBlue}
            />
          ))}
        </Styled.WarningText>
      </Styled.WarningContent>
    </Styled.WarningWrapper>
  );
};
